import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { EnsolversOpsUser } from "../models/EnsolversOpsUser";
import { AccessRoleType } from "../types/AccessRoleType";
import { AppDialog } from "./AppDialog";

interface Props {
  selectedUser: EnsolversOpsUser | undefined;
  setSelectedUser: (user: EnsolversOpsUser | undefined) => void;
  isEditing: boolean;
  setIsEditing: (arg: boolean) => void;
  onRoleChange: (role: string, checked: boolean) => void;
  roles: {
    roleAdmin: boolean;
    roleContractor: boolean;
    roleManager: boolean;
    roleHR: boolean;
    roleHiringManager: boolean;
  };
}

export const EditRoleUser = ({ selectedUser, setSelectedUser, isEditing, setIsEditing, onRoleChange, roles }: Props) => {
  const closeEditRoles = () => {
    setSelectedUser(undefined);
    setIsEditing(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsEditing(true);
    onRoleChange(event.target.name, event.target.checked);
  };

  return (
    <AppDialog
      open={!!selectedUser && !!isEditing}
      hideCancel
      onClose={() => closeEditRoles()}
      buttons={[{ label: "Close", onClick: () => closeEditRoles() }]}
      title={`Edit Roles: ${selectedUser?.firstName} ${selectedUser?.lastName}.`}
      content={
        <>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={roles.roleAdmin} onChange={handleChange} name={AccessRoleType.ROLE_ADMIN} />}
              label="Role Admin"
            />
            <FormControlLabel
              control={<Checkbox checked={roles.roleContractor} onChange={handleChange} name={AccessRoleType.ROLE_CONTRACTOR} />}
              label="Role Contractor"
            />
            <FormControlLabel
              control={<Checkbox checked={roles.roleHR} onChange={handleChange} name={AccessRoleType.ROLE_HR} />}
              label="Role HR"
            />
            <FormControlLabel
              control={<Checkbox checked={roles.roleManager} onChange={handleChange} name={AccessRoleType.ROLE_MANAGER} />}
              label="Role Manager"
            />
            <FormControlLabel
              control={<Checkbox checked={roles.roleHiringManager} onChange={handleChange} name={AccessRoleType.ROLE_HIRING_MANAGER} />}
              label="Role Hiring Manager"
            />
          </FormGroup>
        </>
      }
    />
  );
};
